import React, { useEffect, useState } from 'react';
import { CommonWrapper } from '../../CommonWrapper';
import { useLocale } from 'locale';
import { Button } from 'ds/components/button';
import { Nav } from '../../styled';
import RadioGroup from 'ds/components/input/RadioGroup';
import { useScreenBreakpoint } from 'consts/breakpoints';


interface IImportantArea {
  isActive: boolean;
  isSaved: boolean;
  title: string;
  text?: string;
  btnText?: string;
  setArea: any;
  data: boolean;
  onUpdate: (data: { [key: string]: any }) => void;
  selfClick?: () => void;
  fullActive?: boolean;
}

export const OtherApartmentArea: React.FC<IImportantArea> = ({ isActive, isSaved, title, text, btnText, data, onUpdate, setArea, selfClick, fullActive }) => {
  const { t } = useLocale();
  const [ value, setValue ] = useState(null);
  const screen = useScreenBreakpoint();
  const isMobile = screen === 1;

  useEffect(() => {
    if (data !== null) {
      setValue(data ? '1' : '');
    }
    else {
      setValue(data);
    }
  }, [ data ]);

  const handleRadioChange = (e: React.SyntheticEvent<HTMLInputElement>) => {
    setValue(e.currentTarget.value);
  };

  const handleSubmit = () => {
    setArea();
    onUpdate({ hasProperty: !!value });
  };

  return (
    <CommonWrapper {...{ isActive, isSaved, title, text, selfClick }}>
      <>
        <RadioGroup
          value={value}
          onChange={handleRadioChange}
          name="otherApartmentArea"
          options={[
            { label: t('investors.otherApartment.label', { value: 'no' }), value: '' },
            { label: t('investors.otherApartment.label', { value: 'yes' }), value: '1' },
          ]}
        />
        {isActive ? (
          <Nav>
            <Button size="extraLarge" fullWidth={isMobile} disabled={fullActive ? (value === null || value === (data ? '1' : '')) : (value === null)} onClick={handleSubmit}>{btnText || t('investors.wizard.submitButton')}</Button>
          </Nav>
        ) : null}
      </>
    </CommonWrapper>
  );
};
